import * as React from "react";
import Component from "../../AbstractComponent";
import TextField from "../../Partials/Material/TextField";
import Constants from "../../../Action/Constants";
import { PageTransition } from "../Spinner/PageTransition";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openPropertyOwnerCoachDialog: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    type: "",
    disableButtonDuringRequest: false,
    //company fields
    companyName: "",
    company: null,
    //person fields
    firstName: "",
    lastName: "",
    personDisplayName: "",
    person: null,
    firstNameError: false,
    defaultCompanyName: "",
    companyNameError: false,
    errorFields: null,
    isFinishDialogOpen: false,
    isSaving: false
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openPropertyOwnerCoachDialog: this.props.openPropertyOwnerCoachDialog,
      type: this.props.type,
      companyName: this.props.type === "company" ? this.props.defaultCompanyName : "",
      firstName: this.props.type === "person" ? this.props.defaultCompanyName : "",
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openPropertyOwnerCoachDialog: nextProps.openPropertyOwnerCoachDialog,
      type: nextProps.type,
      companyName: nextProps.type === "company" && !this.state.disableButtonDuringRequest ? nextProps.defaultCompanyName : this.state.companyName,
      firstName: nextProps.type === "person" ? nextProps.defaultCompanyName : "",
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openPropertyOwnerCoachDialog: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      type: "",
      disableButtonDuringRequest: false,
      //company fields
      companyName: "",
      company: null,
      //person fields
      firstName: "",
      lastName: "",
      personDisplayName: "",
      person: null,
      firstNameError: false,
      companyNameError: false,
      errorFields: null,
      isFinishDialogOpen: false,
      isSaving: false
    });
  }

  public onCloseCoach = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);
    
    if(this.props.onCloseCoach){
      this.props.onCloseCoach.call(this, this.state.company);
    }
    if(this.props.setCompanyFromCoach && activeStep === steps.length - 1){
      this.props.setCompanyFromCoach.call(this, this.state.company)
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    if(this.state.type === "company"){
      return [
        this.trans("coach/propertyowner-scenario/company-step/second-title"),
        this.trans("coach/propertyowner-scenario/company-step/third-title"),
        this.trans("coach/propertyowner-scenario/company-step/fourth-title")
      ];

    } else {
      return [
        this.trans("coach/propertyowner-scenario/person-step/second-title"),
        this.trans("coach/propertyowner-scenario/person-step/third-title"),
        this.trans("coach/propertyowner-scenario/person-step/fourth-title"),
        this.trans("coach/propertyowner-scenario/person-step/fifth-title")
      ];
    }
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepFirst();
      case "person":
        return this.personStepFirst();
    }
  }

  public secondStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepSecond();
      case "person":
        return this.personStepSecond();
    }
  }

  public thirdStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepThird();
      case "person":
        return this.personStepThird();
    }
  }

  public fourthStepDetails = () => {
    switch (this.state.type) {
      case "company":
        // return
      case "person":
        return this.personStepFourth();
    }
  }

  //Components
  public companyStepFirst = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/propertyowner-scenario/company-step/step-1-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/propertyowner-scenario/company-step/step-1-subtitle")}
        />
        <div>
          <TextField
            autoComplete="off"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/propertyowner-scenario/company-step/second-field/companyname-label")}
            value={this.state.companyName}
            onChange={this.setCompanyName}
            autoFocus={true}
            variant="standard"
            error={this.state.companyNameError || this.getErrorFor("name")}
          />
          {!!this.getErrorFor("name") ? <div className="component-error-text">{this.getErrorFor("name")}</div> : this.state.companyNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
        </div>
      </div>
    );
  }

  public companyStepSecond = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/propertyowner-scenario/company-step/step-2-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-create-subtitle-dutch-de", {entity: this.trans("owner").toLowerCase()})}
        />
        <CoachSummaryTable
          tableRows={[
            {
              label: this.trans("coach/propertyowner-scenario/company-step/third-info2"),
              value: this.state?.companyName || ""
            }
          ]}
        />
      </div>
    )
  }

  public companyStepThird = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.company ?
          <>
            <Title
              title={this.trans("result")}
            />
            <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
              {this.image.getAvatar("success", { size: 62 })}
            </div>
            <Subtitle
              subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de",{entity: this.trans("owner").toLowerCase()})}
            />
          </>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    )
  }

  public personStepFirst = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/propertyowner-scenario/person-step/step-1-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/propertyowner-scenario/person-step/step-1-subtitle")}
        />
        <div>
        <TextField
          autoComplete="off"
          // id="firstName"
          // name="firstName"
          className="form-element full-size"
          type="text"
          label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
          value={this.state.firstName}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
          autoFocus={true}
          variant="standard"
          error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
        />
        {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

        <TextField
          autoComplete="off"
          // id="lastName"
          // name="lastName"
          className="form-element full-size"
          type="text"
          label={this.trans("coach/propertyowner-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
          value={this.state.lastName}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
          variant="standard"
          error={!!this.getErrorFor("lastName")}
        />
        {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
        </div>
      </div>
    );
  }

  public personStepSecond = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/propertyowner-scenario/company-step/step-1-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/propertyowner-scenario/company-step/step-1-subtitle")}
        />
        <div>
          <TextField
            autoComplete="off"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
            value={this.state.companyName}
            onChange={this.setCompanyName}
            autoFocus={true}
            variant="standard"
            error={this.state.companyNameError || this.getErrorFor("name")}
          />
          {!!this.getErrorFor("name") ? <div className="component-error-text">{this.getErrorFor("name")}</div> : this.state.companyNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
        </div>
        <div className="info-text hint-styles-dialog">
          {this.trans("coach/propertyowner-scenario/person-step/third-info2", {personDisplayName: `'${this.state.personDisplayName}'`})}
        </div>
      </div>
    );
  }

  public personStepThird = () => {

    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/propertyowner-scenario/company-step/step-2-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-create-subtitle-dutch-de", {entity: this.trans("owner").toLowerCase()})}
        />
        <CoachSummaryTable
          tableRows={[
            {
              label: this.trans("coach/propertyowner-field/newperson-label"),
              value: this.state?.personDisplayName
            },
            {
              label: this.trans("coach/propertyowner-field/newcompany-label"),
              value: this.state?.companyName
            }
          ]}
        />
     </div>
    )
  }

  public personStepFourth = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.company ?
          <>
            <Title
              title={this.trans("result")}
            />
            <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
              {this.image.getAvatar("success", { size: 62 })}
            </div>
            <Subtitle
              subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de",{entity: this.trans("owner").toLowerCase()})}
            />
          </>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)
                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    )
  }

  //Funcionality for steps
  //FIRST STEP LOGIC
  public startStep1 = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStep1();
      case "person":
        return this.personStartStep1();
    }
  }

  //SECOND STEP LOGIC
  public startStep2 = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStep2();
      case "person":
        return this.personStartStep2();
    }
  }

    //THIRD STEP LOGIC
    public startStep3 = () => {
      switch (this.state.type) {
        case "company":
          // return
        case "person":
          return this.personStartStep3();
      }
    }

  //Methods for step logic
  public companyStartStep1 = () => {
    if(this.state.companyName === ""){
      this.setState({
        companyNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public companyStartStep2 = () => {
    const pageTemplate = "owner";
    this.saving(() => {
      this.setState({
        disableButtonDuringRequest: true,
        isSaving: true
      })
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.companyName,
            email: "",
            phone: "",
            mainBankAccountId: "",
            address: null,
            amazonFolderName: "",
            note: "",
            pageTemplate: pageTemplate
          }
        },
        onSuccess: (company) => {
          this.setState({
            company: company,
            disableButtonDuringRequest: false,
            errorFields: [],
            isSaving: false
          }, () => this.plusOneStep())
        },
        onError: (error) => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false
          })
        }
      });
    });
  }

  public getPayloadForPerson = (): any => {
    let pageTemplate = "person";
    return {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public personStartStep1 = () => {
    this.setState({
      companyName: this.state.lastName !== "" ?
      this.state.lastName + this.trans("coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label")
      :
      this.state.firstName + this.trans("coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label"),
      personDisplayName: `${this.state.firstName} ${this.state.lastName}`
    })
    if(this.state.firstName === "") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }


  public personStartStep2 = () => {
    if(this.state.companyName === ""){
      this.setState({
        companyNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public personStartStep3 = () => {
    const pageTemplate = "owner";
    this.saving(() => {
      this.setState({
        disableButtonDuringRequest: true,
        isSaving: true
      })
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.companyName,
            email: "",
            phone: "",
            mainBankAccountId: "",
            address: null,
            amazonFolderName: "",
            note: "",
            pageTemplate: pageTemplate,
            contacts: {
              ...this.getPayloadForPerson()
            }
          }
        },
        onSuccess: (company) => {
          this.setState({
            company: company,
            disableButtonDuringRequest: false,
            errorFields: [],
            isSaving: false
          }, () => this.plusOneStep())
        },
        onError: (error) => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false
          })
        }
      });
    });
  }

  //Methods
  public setCompanyName = (event) => {
    this.setState({
      companyName: event.target.value
    })
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public isNextButtonDisabled = () => {
    if ((this.state.activeStep === 0 && this.state.type === "company" && !this.state.companyName) || 
        (this.state.activeStep === 0 && this.state.type === "person" && !this.state.firstName)) {
      return true
    }
    if (this.state.activeStep === 1 && this.state.type === "person" && !this.state.companyName) {
      return true
    }
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openPropertyOwnerCoachDialog}
          onCloseCoach={this.onCloseCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({activeStep, isDisabled: false})
          }}
          showBackButton={true}
          disabled={false}
          disabledBack={false}
          disabledNext={this.isNextButtonDisabled()}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
